import gql from 'graphql-tag';
import React from 'react';
import { Query } from 'react-apollo';
import { RouteComponentProps } from 'react-router';
import { Layout, LayoutContent, Navigation } from '../../../components';
import {
  FufillmentCentersDeliveryListQuery,
  FufillmentCentersDeliveryListQueryVariables,
} from './__generated__/FufillmentCentersDeliveryListQuery';
import './List.scss';

interface FulfillmentCentersDeliveryIndexRouterParams {
  venueId: string;
  fulfillmentCenterId: string;
}

type RouterProps = RouteComponentProps<FulfillmentCentersDeliveryIndexRouterParams>;

interface FulfillmentCentersDeliveryIndexProps extends RouterProps {
  data?: FufillmentCentersDeliveryListQuery;
  loading: boolean;
  error?: Error;
  venueId: string;
}

class FulfillmentCentersDeliveryIndexUnwrapped extends React.Component<FulfillmentCentersDeliveryIndexProps, any> {
  renderContent() {
    if (this.props.loading || !this.props.data) {
      return <p>Loading...</p>;
    } else {
      const { fulfillmentCenter } = this.props.data;
      const { venueId, fulfillmentCenterId } = this.props.match.params;
      const layoutUrl = `/venue/${venueId}/fulfillment-centers/${fulfillmentCenterId}/delivery/layout`;
      const assignmentsUrl = `/venue/${venueId}/fulfillment-centers/${fulfillmentCenterId}/assignments`;
      const statsUrl = `/venue/${venueId}/fulfillment-centers/${fulfillmentCenterId}/live-stats`;

      return (
        <div className='fulfillment-centers-delivery-index-container'>
          <p>
            <a href={`/venue/${venueId}/fulfillment-centers`}>Back</a>
          </p>
          <h1>{fulfillmentCenter.name}</h1>
          <div>
            <a className='fulfillment-centers-delivery-index-link' href={assignmentsUrl}>
              Assignments
            </a>
            <a className='fulfillment-centers-delivery-index-link' href={layoutUrl}>
              Layout
            </a>
            {fulfillmentCenter.isOpen && (
              <a className='fulfillment-centers-delivery-index-link' href={statsUrl}>
                Live session report
              </a>
            )}
          </div>
        </div>
      );
    }
  }

  render() {
    return (
      <Layout>
        <Navigation />
        <Layout.TopBar>
          <Layout.TopBar.Left>
            <Layout.TopBar.Title>Fulfillment Stations</Layout.TopBar.Title>
          </Layout.TopBar.Left>
        </Layout.TopBar>
        <LayoutContent error={this.props.error}>
          <div>{this.renderContent()}</div>
        </LayoutContent>
      </Layout>
    );
  }
}

const query = gql`
  query FufillmentCentersDeliveryListQuery($venueId: ID!, $fulfillmentCenterId: ID!) {
    fulfillmentCenter(venueId: $venueId, fulfillmentCenterId: $fulfillmentCenterId) {
      id
      name
      isOpen
    }
  }
`;

export const FulfillmentCentersDeliveryIndex = (props: RouterProps) => {
  const { venueId, fulfillmentCenterId } = props.match.params;

  return (
    <Query<FufillmentCentersDeliveryListQuery, FufillmentCentersDeliveryListQueryVariables>
      variables={{ venueId, fulfillmentCenterId }}
      query={query}
    >
      {({ loading, error, data }) => {
        return (
          <FulfillmentCentersDeliveryIndexUnwrapped
            {...props}
            loading={loading}
            error={error}
            data={data}
            venueId={venueId}
          />
        );
      }}
    </Query>
  );
};
